import { defineMessage } from 'services/localization';

export const messages = {
    vendorIdFieldText: defineMessage('vendor_id'),
    typeFieldText: defineMessage('type_1'),
    companyNameFieldText: defineMessage('company_name'),
    webAddressFieldText: defineMessage('web_address'),
    salutationFieldText: defineMessage('salutation'),
    firstNameFieldText: defineMessage('first_name'),
    middleNameFieldText: defineMessage('middle_name'),
    lastNameFieldText: defineMessage('last_name'),
    jobTitleFieldText: defineMessage('job_title_1'),
    categoryFieldText: defineMessage('category'),
    commentsFieldText: defineMessage('comments'),
};
